// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../shared/material.module';
import { SharedModule } from '../../shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { BuyerDashboardModule } from '../../buyer-dashboard/buyer-dashboard.module';
import { EntrypointComponent } from './entrypoint/entrypoint.component';
import { InitialUserPasswordComponent } from './initial-user-password/initial-user-password.component';
import { TokenValidationComponent } from './token-validation/token-validation.component';
import { TokenInvalidComponent } from './token-invalid/token-invalid.component';
import { TokenVerificationComponent } from './token-verification/token-verification.component';
import { InitialDealerSetupComponent } from './initial-dealer-setup/initial-dealer-setup.component';
import { TokenExpiredComponent } from './token-expired/token-expired.component';
import { AdditionalAdminsComponent } from './additional-admins/additional-admins.component';

@NgModule({
    declarations: [
        AdditionalAdminsComponent,
        EntrypointComponent,
        InitialDealerSetupComponent,
        InitialUserPasswordComponent,
        TokenExpiredComponent,
        TokenInvalidComponent,
        TokenValidationComponent,
        TokenVerificationComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        MaterialModule,
        ReactiveFormsModule,
        RouterModule,
        BuyerDashboardModule,
        SharedModule,
    ],
})
export class SelfEnrollmentModule {}
